import React from 'react';
import { ShoppingCart } from 'react-feather';
import { useMyCart } from '../api/getMyCart';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from 'lib/auth';

export const CartSummary = () => {
  const { user } = useAuth();

  // ❗ Only fetch the cart if the user is logged in
  const { data, isLoading } = useMyCart({
    config: {
      enabled: !!user,
      retry: false, // prevents multiple retries on 404
    },
  });

  const cart = data?.cart ?? { items: [], subtotal: 0, currency: 'UGX' };
  const itemCount = cart?.items?.reduce((sum, item) => sum + item.quantity, 0) || 0;
  const subtotal = cart?.subtotal || 0;
  const currency = cart?.currency || 'UGX';

  return (
    <div className="relative inline-block">
      <Link
        to="/my-account/cart"
        className="flex items-center gap-2 text-[#AC3F1E] hover:text-[#922f12] transition"
      >
        <div className="relative">
          <ShoppingCart size={22} />

          {/* Bubble count */}
          <AnimatePresence>
            {user && itemCount > 0 && (
              <motion.span
                key="cart-count"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0 }}
                className="absolute -top-2 -right-2 bg-[#AC3F1E] text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-semibold shadow"
              >
                {itemCount}
              </motion.span>
            )}
          </AnimatePresence>
        </div>

        <div className="ml-2 hidden sm:flex flex-col items-start leading-tight">
          <span className="text-xs text-gray-500 uppercase">My Cart</span>

          {/* If not logged in, hide subtotal */}
          {!user ? (
            <span className="text-xs text-gray-400">Login to view</span>
          ) : isLoading ? (
            <span className="text-xs text-gray-400">Loading...</span>
          ) : (
            <span className="text-sm font-semibold text-gray-800">
              {subtotal.toLocaleString()} {currency}
            </span>
          )}
        </div>
      </Link>
    </div>
  );
};
